export default {
	notification_health: 'Starea notificărilor',
	notification_health_summary: 'Rezumat',
	notification_health_loading: 'Se verifică starea notificărilor...',
	notification_health_refresh: 'Reîmprospătare',
	notification_health_fix: 'Ce trebuie făcut',
	notification_health_unavailable: 'Nu s-a putut încărca starea notificărilor',
	notification_health_healthy: 'Sănătos',
	notification_health_blocked: 'Blocat',
	notification_health_degraded: 'Necesită atenție',
	notification_health_no_app_user: 'Fără autentificare în aplicație',
	notification_health_unknown: 'Necunoscut',
	notification_health_app_version: 'Versiunea aplicației',
	notification_health_last_delivery: 'Ultima livrare',
	notification_health_time_just_now: 'chiar acum',
	notification_health_time_minutes: 'acum {count} minut(e)',
	notification_health_time_hours: 'acum {count} oră(ore)',
	notification_health_time_days: 'acum {count} zi(le)',
	notification_health_time_unknown: 'necunoscut',
	notification_health_summary_healthy: 'Notificările ar trebui să funcționeze',
	notification_health_summary_no_app_user: 'Curățătorul nu s-a autentificat în aplicația mobilă',
	notification_health_summary_blocked_no_token: 'Tokenul push lipsește — curățătorul trebuie să deschidă aplicația și să se autentifice',
	notification_health_summary_blocked_off: 'Notificările sunt dezactivate în aplicație',
	notification_health_check_portal_contact_label: 'Contactul din portal există',
	notification_health_check_portal_active_label: 'Contact activ',
	notification_health_check_portal_rooms_label: 'Camere atribuite',
	notification_health_check_portal_shifts_label: 'Ture atribuite',
	notification_health_check_app_user_label: 'Autentificat în aplicația mobilă',
	notification_health_check_push_token_label: 'Token push înregistrat',
	notification_health_check_notification_mode_label: 'Mod notificări',
	notification_health_check_time_schedule_label: 'În fereastra de timp a notificărilor',
	notification_health_check_ios_geo_filter_label: 'Filtru locație iOS',
	notification_health_check_recent_push_attempt_label: 'Încercare push recentă (48h)',
	notification_health_check_last_push_ignored_label: 'Ultimul semnal nu a fost trimis',
	notification_health_check_recent_push_delivered_label: 'Push livrat recent (48h)',
	notification_health_detail_portal_contact_found: 'Găsit în portal',
	notification_health_detail_portal_contact_missing: 'Nu s-a găsit înregistrarea contactului',
	notification_health_detail_portal_active_active: 'Activ',
	notification_health_detail_portal_active_inactive: 'Inactiv',
	notification_health_detail_portal_rooms_assigned: '{count} cameră(e)',
	notification_health_detail_portal_rooms_none: 'Nicio cameră atribuită',
	notification_health_detail_portal_shifts_assigned: '{count} tură(ture)',
	notification_health_detail_portal_shifts_none: 'Nicio tură atribuită',
	notification_health_detail_app_user_logged_in: 'Versiunea aplicației {version}, ultima sincronizare {lastSync}',
	notification_health_detail_app_user_never: 'Nu s-a autentificat niciodată',
	notification_health_detail_push_token_present: 'Token FCM prezent',
	notification_health_detail_push_token_empty: 'Tokenul este gol',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Ora curentă este în program',
	notification_health_detail_time_schedule_outside: 'Ora curentă este în afara programului configurat',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Nicio încercare push în ultimele 48 de ore',
	notification_health_detail_last_push_ignored: 'Ultima solicitare push a fost ignorată (servik neconfigurat pentru zona de lucru)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Nicio livrare reușită în ultimele 48 de ore',
	notification_health_fix_portal_contact: 'Creați acest curățător în panoul Utilizatori',
	notification_health_fix_portal_active: 'Activați comutatorul Activ pentru acest curățător',
	notification_health_fix_portal_rooms: 'Atribuiți cel puțin o cameră acestui curățător',
	notification_health_fix_portal_shifts: 'Atribuiți cel puțin o tură',
	notification_health_fix_app_user: 'Curățătorul trebuie să instaleze aplicația și să se autentifice cu acest număr de telefon',
	notification_health_fix_push_token: 'Rugați curățătorul să deschidă aplicația, să permită notificările în Setări iOS și să se autentifice din nou',
	notification_health_fix_notification_mode: 'Schimbați modul de notificare din Oprit în Mereu în aplicație',
	notification_health_fix_time_schedule: 'Așteptați până la fereastra programată sau schimbați modul în Mereu',
	notification_health_fix_ios_geo_filter: 'Curățătorul este în afara zonei de notificare — rugați-l să deschidă aplicația la fața locului',
	notification_health_fix_last_push_ignored: 'Verificați configurația servik a zonei de lucru pentru camera care a declanșat semnalul',
	notification_health_fix_recent_push_delivered_filters: 'Verificați filtrele de notificare sau setările dispozitivului',
	notification_health_fix_recent_push_delivered_token: 'Înregistrați mai întâi tokenul push',
	notification_health_mode_on: 'Mereu',
	notification_health_mode_off: 'Oprit',
	notification_health_mode_time: 'Pe bază de timp',
	notification_health_mode_location: 'Pe bază de locație',
	notification_health_filter_on: 'Pornit',
	notification_health_filter_off: 'Oprit',
};
